import React, { Component } from "react";
import { connect } from 'react-redux';
import { Icon } from "antd";
import PropTypes from 'prop-types';
import DateSelectorComponent from '../DateTimepicker/DateSelector';
import { InfoContentWrapper, InfoWrapper, DisplayFlexOkay, PrimaryButtonOkay, PopHeader, QASectionWrapper, IconWrap } from './styles';

let currentDates = [];
class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      dates: ""
    };
    this.toTimeFrame = this.toTimeFrame.bind(this);
    this.startDate = this.startDate.bind(this);
    this.endDate = this.endDate.bind(this);
  }

  toTimeFrame = (dates) => {
    if (!dates) {
      this.setState({ dates: "" });
    }
    else {
      currentDates = dates;
    }
  }

  startDate = (dates) => {
    currentDates[0] = dates;
  }
  endDate = (dates) => {
    currentDates[1] = dates;
  }

  render() {
    return (
      <InfoWrapper data-test="document-centre-calender">
        <InfoContentWrapper>
          <IconWrap>
            <Icon type="close" onClick={this.props.onCancel} />
          </IconWrap>
          <PopHeader>
            Pick Time Frame
          </PopHeader>
          <div>
            <QASectionWrapper>
              <DateSelectorComponent
                open={this.props.visible}
                toTimeFrame={this.toTimeFrame}
                startDate={this.startDate}
                endDate={this.endDate}
              />
            </QASectionWrapper>
            <DisplayFlexOkay>
              <PrimaryButtonOkay
                onClick={() => { this.props.onFilterClick(currentDates) }} >
                Filter
            </PrimaryButtonOkay>
            </DisplayFlexOkay>
          </div>
        </InfoContentWrapper>
      </InfoWrapper>
    );
  }
}

Calendar.propTypes = {
  dropdownVal: PropTypes.string,
  visible: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onFilterClick: PropTypes.func.isRequired,
}

const mapStateToProps = state => (
  {
    dropdownVal: state.getIn(['documentCentre', 'selectDropdown'])
  }
);

export default connect(mapStateToProps)(Calendar);
